import { generatePath } from 'react-router-dom';
import { buildTableFiltersSearch } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperationsFromUrlParamState.ts';
import { DEAL_ROUTES, MIP_MANAGE_ROUTES, MIP_ROUTES, PEOPLE_ROUTES, ROUTES } from './routes';

/**
 * Route pattern for a MIP-manage page, e.g. `/deal/:dealId/mip/:mipId/manage/investors`.
 * Use directly with `matchPath`/`useMatch`, or build a concrete URL via {@link mipManagePath}.
 */
export const mipManagePathPattern = (route = ''): string =>
	`${ROUTES.DEAL}${DEAL_ROUTES.MIP}${MIP_ROUTES.MANAGE}${route}`;

/**
 * Single source of truth for assembling `/deal/:dealId/mip/:mipId/manage/...` URLs.
 * Routes with extra params (e.g. `MIP_MANAGE_ROUTES.INVESTOR_DETAILS`) take them via `params`.
 */
export const mipManagePath = (
	route: string,
	params: { dealId: string; mipId: string } & Record<string, string>
): string => generatePath(mipManagePathPattern(route), params);

export const personDetailsPath = (params: { dealId: string; personId: string }): string =>
	generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.PERSON_DETAILS}`, params);

export const investorDetailsPath = (params: {
	dealId: string;
	mipId: string;
	investorId: string;
}): string => mipManagePath(MIP_MANAGE_ROUTES.INVESTOR_DETAILS, params);

export const documentsForInvestmentPath = (params: {
	dealId: string;
	mipId: string;
	investmentWorkflowId: string;
}): string => {
	const pathname = mipManagePath(MIP_MANAGE_ROUTES.DOCUMENTS, {
		dealId: params.dealId,
		mipId: params.mipId,
	});
	const search = buildTableFiltersSearch([
		{ id: 'investmentWorkflowId', value: params.investmentWorkflowId },
	]);
	return `${pathname}?${search}`;
};
